import { TableInstance } from 'react-table'
import Page from './Page'
// import GoTo from './GoTo'
// import Showing from './Showing'
import Buttons from './Buttons'

const Pagination = <T extends object>({
  // rows,
  pageCount,
  pageOptions,
  canPreviousPage,
  canNextPage,
  gotoPage,
  previousPage,
  nextPage,
  // setPageSize,
  state
}: TableInstance<T>) => (
  <div className="flex items-center justify-between mt-3 text-gray-400 text-sm">
    <Page pageIndex={state.pageIndex} length={pageOptions.length} />

    {/* <GoTo
      pageIndex={state.pageIndex}
      gotoPage={gotoPage}
      length={rows.length}
    /> */}

    {/* <Showing
      pageSize={state.pageSize}
      setPageSize={setPageSize}
      length={rows.length}
      sizes={[10, 20, 30, 40, 50]}
    /> */}

    <Buttons
      canPreviousPage={canPreviousPage}
      canNextPage={canNextPage}
      gotoPage={gotoPage}
      previousPage={previousPage}
      nextPage={nextPage}
      pageCount={pageCount}
    />
  </div>
)

export default Pagination
